var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-centered absolute-top dark-stars",attrs:{"id":"ConnectingToServer"}},[_c('div',[_c('Logo'),_c('div',{staticClass:"loading-message loading-dots"},[_vm._v("Connecting to Mothership")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }